var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
export var LOCAL_STORAGE_KEY = "filterPerksByLocation";
var LocationTags = /** @class */ (function () {
    function LocationTags() {
    }
    LocationTags.prototype.list = function () {
        return getLocationTagsFromLocalStorage();
    };
    LocationTags.prototype.set = function (arr) {
        setLocationTagsToLocalStorage(arr);
        return arr;
    };
    LocationTags.prototype.removeOldFromLocalStorage = function (tags) {
        var _this = this;
        var toRemove = this.list().filter(function (test) {
            var found = false;
            tags.forEach(function (tag) {
                if (tag.uuid === test) {
                    found = true;
                }
            });
            return found;
        });
        toRemove.forEach(function (tag) { return _this.remove(tag); });
    };
    LocationTags.prototype.add = function (toAdd) {
        var arr = __spreadArrays(getLocationTagsFromLocalStorage(), [toAdd]);
        setLocationTagsToLocalStorage(arr);
        return arr;
    };
    LocationTags.prototype.remove = function (toRemove) {
        var arr = __spreadArrays(getLocationTagsFromLocalStorage()).filter(function (t) { return t !== toRemove; });
        setLocationTagsToLocalStorage(arr);
        return arr;
    };
    LocationTags.prototype.clear = function () {
        setLocationTagsToLocalStorage([]);
        return getLocationTagsFromLocalStorage();
    };
    return LocationTags;
}());
export default new LocationTags();
function setLocationTagsToLocalStorage(arr) {
    window.localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(arr));
}
function getLocationTagsFromLocalStorage() {
    try {
        var tags = JSON.parse(window.localStorage.getItem(LOCAL_STORAGE_KEY));
        if (Array.isArray(tags)) {
            return tags;
        }
    }
    catch (e) {
        /* no-op */
    }
    return [];
}
